export default function hideScroll(callbackAtBottom, callbackAtNotBottom) {
  const winScroll : number =
    document.body.scrollTop || document.documentElement.scrollTop;
  const height : number =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;

  if (Math.floor(winScroll - height) === 0) {
    callbackAtBottom();
  } else {
    callbackAtNotBottom();
  }
}
